import React from 'react'
import { connect } from 'react-redux'
import { Flex, Box } from 'grid-styled'
import { reduxForm } from 'redux-form'
import moment from 'moment'

import { fetchECLocations } from 'alelo-logic/actions'

import Button from 'app/elements/Button'

import { labels, queryPlateTitle, queryPlateSubtitle } from './data.json'
import { LocationField, PlateField, PeriodInitDateField, PeriodEndDateField } from './form-fields'
import {
  FormSimpleContent,
  SimpleFormQueryButtonContainer,
  Divider,
  Container,
  CarPlateQueryTitle,
  CarPlateQuerySubtitle
} from './styles'

const dateFormat = 'DD/MM/YYYY'

class CarPlateForm extends React.Component {
  constructor(props) {
    super(props)

    const today = moment().format(dateFormat)
    this.initialValues = {
      periodInitDate: today,
      periodEndDate: today
    }
  }

  componentWillMount() {
    this.props.initialize({ ...this.initialValues, ...this.props.formValues })
  }

  componentDidMount() {
    this.props.fetchLocations()
  }

  render() {
    const { handleSubmit, locations } = this.props

    return (
      <FormSimpleContent>
        <Container>
          <CarPlateQueryTitle>{queryPlateTitle}</CarPlateQueryTitle>
          <CarPlateQuerySubtitle>{queryPlateSubtitle}</CarPlateQuerySubtitle>

          <form onSubmit={handleSubmit}>
            <Flex wrap>
              <Box width={1} mb={3}>
                <LocationField locations={locations} />
              </Box>
              <Box width={1} mb={3}>
                <PlateField />
              </Box>
              <Box width={1} mb={3}>
                <div style={{ display: 'flex', direction: 'row' }}>
                  <Box width={1 / 2}>
                    <PeriodInitDateField dateFormat={dateFormat} />
                  </Box>
                  <Divider />
                  <Box width={1 / 2}>
                    <PeriodEndDateField dateFormat={dateFormat} />
                  </Box>
                </div>
              </Box>
              <Box width={1}>
                <SimpleFormQueryButtonContainer>
                  <Button text={labels.submitButton} type="submit" />
                </SimpleFormQueryButtonContainer>
              </Box>
            </Flex>
          </form>
        </Container>
      </FormSimpleContent>
    )
  }
}

const mapStateToProps = ({ reducer }) => ({
  saving: reducer.formState.saving,
  locations: reducer.ecLocations
})

const mapDispatchToProps = dispatch => ({
  fetchLocations: () => dispatch(fetchECLocations())
})

const form = reduxForm({
  form: 'carPlateForm',
  destroyOnUnmount: false
})(CarPlateForm)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/app/pages/ec/CarPlateQuery/form-simple.js